import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';

import { CoreOffcanvasComponent } from '../../../ui-components/core-offcanvas/core-offcanvas.component';
import { CreateOrganizationTabOneComponent } from './create-organization-tab-one/create-organization-tab-one.component';
import { CreateOrganizationTabThreeComponent } from './create-organization-tab-three/create-organization-tab-three.component';
import { AppMessageService } from '../../../shared/services/app-message/app-message.service';
import { OrganizationService } from '../services/organization.service';
import { TranslateService } from '@ngx-translate/core';
import { OrganizationStatusEnum } from '../../../shared/pipes/organization-status-pipe';
import { CreateOrganizationTabTwoComponent } from './create-organization-tab-two/create-organization-tab-two.component';

@Component({
  selector: 'app-create-organization',
  templateUrl: './organization-create.component.html',
  styleUrl: './organization-create.component.scss',
})
export class CreateOrganizationComponent {
  @ViewChild('orgCanvas') orgCanvas: CoreOffcanvasComponent;
  selectedFile: any;

  @ViewChild('orgCreateTabOne')
  orgCreateTabOne: CreateOrganizationTabOneComponent;
  @ViewChild('orgCreateTabThree')
  orgCreateTabThree: CreateOrganizationTabThreeComponent;

  @ViewChild('orgCreateTabTwo')
  orgCreateTabTwo: CreateOrganizationTabTwoComponent;

  @Output() newItemToOrganizationListOn = new EventEmitter();
  @Output() updateOrgItemOn = new EventEmitter();

  selectedTab: 'organization' | 'vehicle' | 'file' = 'organization'; // Varsayılan sekme
  header: string = '';

  mode: 'create' | 'edit' | undefined;
  clickedData: any = null;
  isSubmit = false;

  fileRes: any[] = [];
  orgId = null;

  savedFileResponses: any[] = []; // Define an array to store responses
  selectedVehicle: any;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly orgService: OrganizationService,
    private readonly appMessageService: AppMessageService,
    private readonly translate: TranslateService
  ) {}


  onOffCanvasClosed() {
    this.orgId = null;
    this.header = '';
    this.orgCreateTabOne?.resetValues();
    this.orgCreateTabTwo?.resetValues();
    this.clearForms();
  }

  openCanvas(data: any) {
    if (data) {
      this.orgId = data.id;
      this.header = this.orgId ? ` | ${this.orgId} - ${data?.name}` : '';
      this.mode = 'edit';
      this.clickedData = data;
      this.orgCreateTabOne.initialize(data);

      setTimeout(() => {
        this.orgCreateTabThree.initialize(data);
      }, 150);

    } else {
      this.mode = 'create';
      this.clickedData = null;
      this.orgCreateTabOne.initialize();
      this.orgId = null;

      setTimeout(() => {
        this.orgCreateTabThree.initialize(null);
      }, 150);
    }

    this.orgCanvas.openPopup();
  }

  update() {
    this.isSubmit = true;
    const fieldLabels: any = {
      name: 'Organizasyon Adı',
      organizationType: 'Organizasyon Tipi',
      startDate: 'Başlangıç Tarihi',
      endDate: 'Bitiş Tarihi',
      startTime: 'Başlangıç Saati',
      durationHours: 'Süre (Saat)',
      durationMinutes: 'Süre (Dakika)',
      address: 'Adres',
      instituation: 'Kurum',
      authorizedPerson: 'Yetkili Kişi',
      authorizedPhone: 'Yetkili Telefon Başında 0 olmadan 10 haneli',
    };

    const invalidFields = Object.keys(this.orgCreateTabOne.createForm.controls)
  .filter(key => this.orgCreateTabOne.createForm.get(key)?.invalid)
  .map(key => fieldLabels[key] || key);

    // Mark all controls as touched to show validation errors
    this.orgCreateTabOne.createForm.markAllAsTouched();

    if (this.orgCreateTabOne.createForm.invalid) {
      this.appMessageService.errorToast(
        'Eksik Alanlar',
        `Lütfen doldurun: ${invalidFields.join(', ')}`
      );
      return;
    }

    if (this.orgCreateTabOne.createForm.getRawValue().cancelled) {
      this.orgCreateTabOne.createForm.patchValue({
        status: OrganizationStatusEnum.CANCELLED,
      });
    }

    const formData = new FormData();
    const uploadedFilesRaw = this.orgCreateTabThree.fileForm?.value?.uploadedFiles ?? [];

    const uploadedFiles = uploadedFilesRaw.map((f: any) => {
      const { file, ...rest } = f; 
      return rest;
    });

    const updatedObj = {
      id: this.orgId,
      ...this.orgCreateTabOne.createForm.value,
      startDate: new Date(this.orgCreateTabOne.createForm.value.startDate),
      endDate: new Date(this.orgCreateTabOne.createForm.value.endDate),
      duration:
        this.orgCreateTabOne.createForm.value.durationHours != null &&
        this.orgCreateTabOne.createForm.value.durationMinutes !== null
          ? `${this.orgCreateTabOne.createForm.value.durationHours}:${this.orgCreateTabOne.createForm.value.durationMinutes}`
          : null,
      amount: this.orgCreateTabOne.createForm.value.amount,
      protocolNo: this.orgCreateTabOne.createForm.value.protocolNo,
      ambulanceCount: this.orgCreateTabOne.createForm.value.ambulanceCount,
      status: this.orgCreateTabOne.createForm.getRawValue().status,
      uploadedFiles,
      plannedVehicles:
        this.orgCreateTabOne.plannedVehiclesList?.map((p) => ({
          id: p?.id ?? undefined,
          vehicleId: p?.vehicle?.id,
          organizationId: this.orgId,
          protocolNo112: p?.protocolNo112,
        })) ?? [],
    };
    formData.append('data', JSON.stringify(updatedObj));

    if (
      this.orgCreateTabThree.fileForm?.value?.editModeUploadedFiles?.length > 0
    ) {
      for (const file of this.orgCreateTabThree.fileForm?.value?.editModeUploadedFiles ?? []) {
        formData.append('files', file.file); // aynı isimle çoklu gönderim
        formData.append('fileDescription', file?.fileDescription ?? ''); // aynı isimle çoklu gönderim
      }

    }
    this.orgService.update(formData).subscribe((orgUpdateRes) => {
      this.appMessageService.successToast(
        this.translate.instant('common.update'),
        this.translate.instant('common.updateSuccessToastMessage')
      );
      this.updateOrgItemOn.emit(orgUpdateRes);
      this.clearForms();
      this.orgCanvas.closePopup();
    });
  }

  save() {
    this.isSubmit = true;

    const fieldLabels: any = {
      name: 'Organizasyon Adı',
      organizationType: 'Organizasyon Tipi',
      startDate: 'Başlangıç Tarihi',
      endDate: 'Bitiş Tarihi',
      startTime: 'Başlangıç Saati',
      durationHours: 'Süre (Saat)',
      durationMinutes: 'Süre (Dakika)',
      address: 'Adres',
      instituation: 'Kurum',
      authorizedPerson: 'Yetkili Kişi', 
      authorizedPhone: 'Yetkili Telefon Başında 0 olmadan 10 haneli',
    };

    const invalidFields = Object.keys(this.orgCreateTabOne.createForm.controls)
      .filter(key => this.orgCreateTabOne.createForm.get(key)?.invalid)
      .map(key => fieldLabels[key] || key);

    // Mark all controls as touched to show validation errors
    this.orgCreateTabOne.createForm.markAllAsTouched();

    if (this.orgCreateTabOne.createForm.invalid) {
  this.appMessageService.errorToast(
    'Eksik Alanlar',
    `Lütfen doldurun: ${invalidFields.join(', ')}`
  );
  return;
}

    const formData = new FormData();
    const createObj = {
      ...this.orgCreateTabOne.createForm.value,
      startDate: new Date(this.orgCreateTabOne.createForm.value.startDate),
      endDate: new Date(this.orgCreateTabOne.createForm.value.endDate),
      duration:
        this.orgCreateTabOne.createForm.value.durationHours != null &&
        this.orgCreateTabOne.createForm.value.durationMinutes !== null
          ? `${this.orgCreateTabOne.createForm.value.durationHours}:${this.orgCreateTabOne.createForm.value.durationMinutes}`
          : null,
      amount: this.orgCreateTabOne.createForm.value.amount,
      protocolNo: this.orgCreateTabOne.createForm.value.protocolNo,
      ambulanceCount: this.orgCreateTabOne.createForm.value.ambulanceCount,
      cancelDescription: '',
      recurrings: this.orgCreateTabOne.recurrings,
     plannedVehicles:
        this.orgCreateTabOne.plannedVehiclesList?.map((p) => ({
          vehicleId: p?.vehicle?.id,
          protocolNo112: p?.protocolNo112,
        })) ?? [],
    };
    formData.append('data', JSON.stringify(createObj));
    if (this.orgCreateTabThree.fileForm?.value?.uploadedFiles?.length > 0) {
      for (const file of this.orgCreateTabThree.fileForm?.value?.uploadedFiles ?? []) {
        formData.append('files', file.file); // aynı isimle çoklu gönderim
        formData.append('fileDescription', file?.fileDescription ?? ''); // aynı isimle çoklu gönderim
      }

    }
    this.orgService.create(formData).subscribe({
      next: (orgCreateRes) => {
        this.appMessageService.successToast(
          this.translate.instant('common.success'),
          this.translate.instant('common.saveSuccessToastMessage')
        );

        this.newItemToOrganizationListOn.emit(orgCreateRes?.id);
        this.clearForms();
        this.orgCanvas.closePopup();
      },
      error: () => {},
    });
  }

  clearForms() {
    this.orgCreateTabThree?.resetForm();
    this.orgId = null;
    this.clickedData = null;
    this.mode = undefined;
    this.isSubmit = false;
    this.savedFileResponses = [];
    this.selectedTab = 'organization';
  }

  // Sekme değiştirme metodu
  setTab(tab: 'organization' | 'vehicle' | 'file') {
    this.selectedTab = tab;
    this.orgCreateTabTwo?.resetValues();
    setTimeout(() => {
      if (tab === 'file') {
        this.orgCreateTabThree?.initialize(this.clickedData);
      }
      if (tab === 'vehicle') {
        this.orgCreateTabTwo?.initialize(
          this.clickedData?.organizationVehicles ?? [],
          this.clickedData?.startDate,
          this.clickedData?.endDate
        );
      }
    }, 100);
  }
}
